import { ContextualMenu, Icon, Stack } from "@fluentui/react";
import React, { useContext,useState,useRef,useCallback } from "react";
import RowBadge from "./Badge/RowBadge";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import studylistContext from "../../../context/studylist/StudylistContext";
import { IconButton } from "@fluentui/react";
import userContext from "../../../context/users/UserContext";
import {
  mainStackStyles,
  patientIdStyle,
  patientGenderStyle,
  patientAgeStyle,
  patientAgeChatContainer,
  patientAgeContainer,
  patientChatContainer,
  popDotStyle,
  countMessageStyle,
} from "../helpers/mobileUtilities";
import { HIDE_ASSIGN_DROPDOWN_TABS, MODAL_TYPE, TAB_NAME, USERTYPES, modalityRowBadgeColor } from "../../../constants/Constants";
import themeContext from "../../../context/theme/ThemeContext";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import { t } from "i18next";
import { RevertCloseStudyApi, addToLibraryApi, removeFromLibraryApi } from "../../../service/StudyListService";
import CloseStudy from "./Actions/CloseStudy";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import loaderContext from "../../../context/loader/LoaderContext";
import { HistoryAttachment } from "./StudyDetails";
import UploadHistory from "./UploadHistory/UploadHistory";
import { capitalizeFullName } from "../helpers/helpingFunctions";
import toastContext from "../../../context/toast/ToastContext";


const MobileListComponent = (props) => {
  const {
    returnedReasonCount,
    setShowCommunicationModal,
    showReturnedStudyReasonModal,
    setShowReturnedStudyReasonModal,
    mobileAssignmentObject,
    setMobileAssignmentObject,
    showVersionModalForReport,dataQueryState, setDataQueryState,
    refreshRequired, setRefreshRequired,
    allDataElement, setAllDataElement
  } = useContext(studylistContext);

  const {
    } = useContext(studylistContext);


    const {
      setStudyParentId,
      openReportModal,
      setOpenReportModal,
      setModalityReport,
      reportDetails,
      getData,
      studyParentId,
      setFirmId,
      firmId,
      setIsExternal,
      handlePreviewReport,
      downloadReport,
      setAlertSuccessModal,
      alertSuccessModal,
      getConsistentCustomDateFormat, getConsistentDateFormat,
      externalReportingModalRef,externalReportingLoading,setExternalReportingLoading
    } = useContext(studyReportContext);

  const { theme,themeName } = useContext(themeContext);
  const { roles, authenticated, loadByUsername, showConfirmation } =
    useContext(userContext);
    const { setLoaderRunning, ref, setShowModal, showModal} = useContext(loaderContext);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showReInferenceModal, setShowReInferenceModal] = useState(false);
    const [showCloseStudyModal, setShowCloseStudyModal] = useState(false);    
    const [showCloseStudyResponseModal, setShowCloseStudyResponseModal] = useState(false);
    const [showCloseStudyReponseMsg, setShowCloseStudyReponseMsg] = useState("");
    const [showHistoryAttachment, setShowHistoryAttachment] = useState(false);

  let study = props.data.row.original;
  let studyId = props.data.row.original.id;
  let patientName = props.data.row.original.patientName;
  let patientId = props.data.row.original.patientId;
  let enterprise =
    process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" ||
    process.env.REACT_APP_ENTERPRISE_PLATFORM == true
      ? true
      : false;

  const extractCorrectAge = (str) => {
    if (str[str.length - 1] == "Y" && str[0] == "0") {
      return str.substring(1, str.length - 1);
    }
    return str;
  };

  const badgeStyle = {
    backgroundColor: "#BBDEFF",
    height: "18px",
    fontSize: "10px",
    color: "#0035BE",
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    fontFamily: "Open Sans",
    fontWeight: "700",
    padding: "0px 5px",
    borderRadius: "10px",
    lineHeight: "16px",
    gap: "10px",
  };

  const handleCloseStudy = () =>{
    setShowConfirmModal(true);
    setShowCloseStudyModal(true);
  }

  const handleCloseStudyResponseCloseModal = () =>{
    setShowCloseStudyResponseModal(false);
  }

  const handleAddToLibrary = async() =>{
    const response = await addToLibraryApi(studyId);
    console.log("---- Library added ----",response);
    if(response.data.result == "SUCCESS"){
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description =  t("string-literals.add-to-library-success");
        return newItem;
      });

      setAllDataElement(prevData => {
        const newData = [...prevData];
        newData[props.data.row.index] = {
          ...newData[props.data.row.index], 
          libraryStudy: true 
        };
        return newData;
      });
      setTimeout(()=>{
        setRefreshRequired(()=>{
          const newItem = {...refreshRequired};
          newItem[TAB_NAME.LIBRARY].alreadyLoaded = false;
          return newItem;
        });
      },10);
      

    }else{
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  }

  const handleRemoveFromLibrary = async() =>{
    const response = await removeFromLibraryApi(studyId);

    if(response.data.result == "SUCCESS"){
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.removed-to-library-success");
        return newItem;
      });
      if(props.tabId == TAB_NAME.LIBRARY){

        setTimeout(()=>{
          setRefreshRequired(()=>{
            const newItem = {...refreshRequired};
            newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
            console.log(newItem);
            return newItem;
          });
        },10);  
        setAllDataElement(prevData => {
          const newData = prevData.filter(element => element.id !== studyId);
          return newData;
        });    
      }else{
        setAllDataElement(prevData => {
          const newData = [...prevData];
          newData[props.data.row.index] = {
            ...newData[props.data.row.index], 
            libraryStudy: false 
          };
          return newData;
        });
      }
      


    }else{
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  }

  const handleRevertCloseStudyApiFunc = async() =>{
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await RevertCloseStudyApi(studyId, props.data.row.original.assignmentList[0].id);
    if(response.data.message === "database_error"){
      // setShowRevertStudyResponseMsg(t("confirm-message.revert-closeStudy-database-error-message"));
      setLoaderRunning(false);
      ref.current.complete();
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("confirm-message.revert-closeStudy-database-error-message");
        return newItem;
      });
       

      
    }else{
      // setShowRevertStudyResponseMsg(response.data.message);
      setLoaderRunning(false);
      ref.current.complete();
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = response.data.message;
        return newItem;
      });

      setRefreshRequired(()=>{
        const newItem = {...refreshRequired};
        newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
        return newItem;
      });

    let newData = dataQueryState?.data?.rows.filter(
      (row) => row.id !== props.data.row.original.id
    );
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      newValue.data.rows = newData;
      return newValue;
    });
    }
  }

  const menuPropsItems = () =>{
    let items = [];
    
    if(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN ||  roles[0] == USERTYPES.SUPERVISOR){
      if(study.assignmentList[0].closed == 0 && study.reportDoneStatus != 2 && props.data.row.depth === 0){
        items.push({
          key: 'CloseStudy',
          iconProps: { iconName: 'CloseStudyIcon',className: 'study-list-action-icon-class' },
          text: t("study-list.actions.close-study"),
          onClick: () => handleCloseStudy(),
        });
      }
      if(props.data.row.depth === 0 && study.assignmentList[0].closed > 0 && study.reportDoneStatus != 2 && (study.assignmentList[0].closed == study.assignmentList[0].firmId)){
        items.push({
          key: 'RevertCloseStudy',
          iconProps: { iconName: 'RevertCloseStudyIcon',className: 'study-list-action-icon-class' },
          text: t("study-list.actions.revert-close-study"),
          onClick: () => handleRevertCloseStudyApiFunc(),
        });
      }
      if(study.assignmentList[0].closed != 0 && study.reportDoneStatus != 2 && props.tabId == 'closed'  && props.data.row.depth === 0 ){
        items.push({
          key: 'closeStudyReason',
          iconProps: {iconName: 'ReturnStudyIcon',className: 'study-list-action-icon-class'},
          text: t("study-list.actions.close-study-reason"),
          onClick:() => {
            console.log("---Clicked---");
            setShowModal(() => {
              const newItem = { ...showModal };
              newItem.show = true;
              newItem.type = MODAL_TYPE.ALERT_MODAL;
              newItem.heading = "Closing Reasons";
              newItem.isError = false;
              newItem.isSuccess = false;
              newItem.isWarning = true;
              newItem.description = study.assignmentList[0].closingReason;
              return newItem;
            });
          }
        });
      }
    
    if(roles[0] == USERTYPES.RADIOLOGIST){
      if(!study.libraryStudy){
        if(props.data.row.depth === 0){
          items.push({
            key: 'AddToLibrary',
            iconProps: {iconName: 'AddToLibraryIcon',className: 'study-list-action-icon-class'},
            text: t("study-list.actions.add-to-library"),
            onClick:() => handleAddToLibrary()
          });
        }
        
      }else{
        if(props.data.row.depth === 0){
          items.push({
            key: 'RemoveFromLibrary',
            iconProps: {iconName: 'RemoveFromLibraryIcon',className: 'study-list-action-icon-class'},
            text: t("study-list.actions.remove-from-library"),
            onClick:() => handleRemoveFromLibrary()
          });
        }
      }
    }
      
      // items.push({
      //   key: 'viewReportHistory',
      //   iconProps: {iconName: 'ReportHistoryIcon',className: 'study-list-action-icon-class'},
      //   text: t("study-list.actions.report-history"),
      //   onClick:() => {}
      //     //handleViewReportHistory()
      // });
    }
    // if(roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.FIRMTECHNICIAN){
    //     if(study.wordFilePath != null && study.wordFilePath != ""){
    //       items.push({
    //         key: 'viewReportHistory',
    //         iconProps: {iconName: 'ReportHistoryIcon',className: 'study-list-action-icon-class'},
    //         text: t("study-list.actions.report-history"),
    //         onClick:() => {} 
    //           //handleViewReportHistory(false)
    //       });
    //     }
    //  }


    if(
      (roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST
      || roles[0] == USERTYPES.SUPERVISOR) &&
       (study.reportDoneStatus == 1 || study.reportDoneStatus == 2)){
        items.push({
          key: 'Preview',
          iconProps: { iconName: 'PreviewStudyListIcon',className: 'study-list-action-icon-class' },
          text: 'Preview Report',
          onClick: () => handlePreviewReport(studyId, study.reportDoneStatus),
        });
      }

      items.push({
        key: 'ViewHistoryAttachment',
        iconProps: {iconName: 'UploadHistoryIcon',className: 'study-list-action-icon-class'},
        text: roles[0] !== USERTYPES.RADIOLOGIST ? t("upload-history.title") : t("upload-history.view-history"),
        onClick:() => setShowHistoryAttachment(true)
      });

    return items;
  }

  const menuProps = {
    shouldFocusOnMount: true,
    items: menuPropsItems(),
  };

  const checkForAssignementAccess = () => {
    if((roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR) && props.data.row.original.allowAssignment && !HIDE_ASSIGN_DROPDOWN_TABS.includes(props.tabId)){
      return true;
    }
    return false;
  }

  const checkForProviderAccess = () => {
    if(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.RADIOLOGIST){
      return true;
    }
    return false;
  }

  const checkForClientAccess = () => {
    if(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR){
      return true;
    }
    return false;
  }

  const getProviderName = () => {
    let nameStr = "";
    if(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.RADIOLOGIST){
      if(props.data.row.original.assignmentList[0]?.closedByProvider){
        nameStr += `${t("label.closed")} `;
      }
      nameStr += props.data.row.original.assignmentList[0].providerName !=
      undefined ? props.data.row.original.assignmentList[0].providerName : "-";
    }
    return nameStr;
  }

  const getClientName = () => {
    if(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR){
      return props.data.row.original.assignmentList[0].clientName !=
      undefined ? props.data.row.original.assignmentList[0].clientName : "-";
    }
    return "-";
  }

  const checkForAnyUploadedHistory = () => {
    if((props.data.row.original?.historyStatus == null || props.data.row.original?.historyStatus == false) && props.data.row.original?.studyHistoryDocList?.length == 0){
        return false;
    }else{
      return true;
    }
  }

  const checkForRoleForHistoryIcon = () => {
    if(roles[0] !== USERTYPES.RADIOLOGIST){
      return true;
    }
    return false;
  }

  return (
    <>
      <Stack style={{ ...mainStackStyles }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
           {showCloseStudyModal &&
        <CloseStudy showCloseStudyModal={showCloseStudyModal} setShowCloseStudyModal={setShowCloseStudyModal} setShowCloseStudyResponseModal={setShowCloseStudyResponseModal} studyId={studyId} setShowConfirmModal={setShowConfirmModal} setShowCloseStudyReponseMsg={setShowCloseStudyReponseMsg} patientName={patientName} patientId={patientId}/>
      }
      {showCloseStudyResponseModal && showConfirmModal &&
        <ConfirmModal handleConfirm={handleCloseStudyResponseCloseModal} handleNotConfirm={handleCloseStudyResponseCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showCloseStudyReponseMsg}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      }
      {showHistoryAttachment &&
        <UploadHistory 
        setShowUploadHistoryModal={setShowHistoryAttachment} 
        showUploadHistoryModal={showHistoryAttachment} 
        studyId={props.data.row.original.id} 
        isChild={props.data.row.depth !== 0}
        activeData = {props.data.row.original.fromActiveData}
        clientId={props.data.row.original.assignmentList[0]?.clientId} 
        firmId = {props.data.row.original.assignmentList[0]?.firmId} 
        modalityId = {props.data.row.original.modalityId}
        />
      }
      {
        checkForAnyUploadedHistory() && <div className={`${checkForRoleForHistoryIcon()?"mobile-add-history-icon":"mobile-add-provider-icon"}`}>
          <IconButton
              iconProps={{ iconName: checkForRoleForHistoryIcon() ? "DownloadDocument":"FilePDB" }}
              style={{ color: "#0082F9", border: "none", outline: "none" }}
              onClick={(ev)=>{
                ev.stopPropagation();
                setShowHistoryAttachment(true);
              }}
            />
        </div>
      }

          {checkForAssignementAccess() && <div className="mobile-add-provider-icon">
            <IconButton
              iconProps={{ iconName: "AddFriend" }}
              style={{ color: "#0082F9", border: "none", outline: "none" }}
              onClick={(ev)=>{
                ev.stopPropagation();
                console.log("--- CLicking provider ---");
                setMobileAssignmentObject(()=>{
                  const newItem = {...mobileAssignmentObject};
                  newItem.showProviderFilter = true;
                  newItem.index = 0;
                  newItem.data = props.data;
                  return newItem;
                })
              }}
            />
          </div>}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span className="study-list-mobile-patientDetails-name">
                {capitalizeFullName(props.data.row.original.patientName)}
              </span>
            </div>

            <div style={{ height: "fit-content", display: "flex" }}>
              <div
                style={patientChatContainer}
                onClick={(event) => {
                  event.stopPropagation();
                  setShowCommunicationModal({
                    studyId: props.data.row.original.id,
                    show: true,
                  });
                }}
              >
                {props.data.row.original.userSpecificMessageCount > 0 && (
                  <div style={popDotStyle}>
                    <span style={countMessageStyle}>
                      {props.data.row.original.userSpecificMessageCount}
                    </span>
                  </div>
                )}
                {/* <RowBadge
                name={props.data.row.original.modality.name}
                style={badgeStyle}
              /> */}
                <div
                  style={{
                    marginLeft: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <ChatIcon
                    color={theme.palette.inactiveTool}

                    active={
                      props.data.row.original.userSpecificMessageCount > 0
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
              <ActionDropdown menuItems={menuPropsItems} />
            </div>
          </div>
          <div style={patientAgeChatContainer}>
            <div style={patientAgeContainer}>
              <span style={patientGenderStyle}>
                {props.data.row.original.patientSex}
              </span>
              <span style={{ marginLeft: "4px", marginRight: "4px" }}>|</span>
              <span style={patientAgeStyle}>
                {props.data.row.original.patientAge == 0
                  ? props.data.row.original.patientAge.substring(1)
                  : extractCorrectAge(props.data.row.original.patientAge)}
              </span>
            </div>
            <div style={patientChatContainer}>
              <RowBadge
                customClassName = "study-list-modality-badge"
                colorObj={modalityRowBadgeColor(
                  props.data.row.original.modality.name
                )}
                name={props.data.row.original.modality.name}
              />
              <span
                className="study-list-mobile-study-date-txt"
                style={{ marginLeft: "10px" }}
              >
                {`ID: `}
                <span className="study-list-value-text">
                  {props.data.row.original.patientId}
                </span>
              </span>
            </div>
          </div>
          <div style={{ display: "flex", width:"100%" }}>
            <div style={{ display: "flex", flexDirection: "column", width:"25%" }}>
              <span className="study-list-mobile-study-date-txt">{`Study Date: `}</span>
              <span className="study-list-mobile-study-date-txt">{`${t("label.total-images")}: `}</span>
              {checkForClientAccess() && <span className="study-list-mobile-study-date-txt">{`Client: `}</span>}
              {checkForProviderAccess() && <span className="study-list-mobile-study-date-txt">{`${roles[0] === USERTYPES.RADIOLOGIST?"Radiologist":"Provider"}: `}</span>}
              {checkForProviderAccess() && <span className="study-list-mobile-study-date-txt">{`Assigned On: `}</span>}
              <span className="study-list-mobile-study-date-txt">{`Description: `}</span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width:"70%"
              }}
            >
              <span className="study-list-value-text">
                {getConsistentDateFormat(
                  props.data.row.original.studyDateDisplay
                )}
              </span>
              <span className="study-list-value-text">
                {props.data.row.original.noOfImages}
              </span>
              {checkForClientAccess() && <span className="mobile-study-list-text-value" style={{ width: "230px",display:'block' }}>
                {getClientName()}
              </span>}
              {checkForProviderAccess() && <span className="mobile-study-list-text-value" style={{ width: "230px",display:'block' }}>
                {getProviderName()}
              </span>}
              {checkForProviderAccess() && <span className="study-list-value-text">
                {getConsistentCustomDateFormat(
                  props.data.row.original.assignmentList[0]
                    .assignmentDateDisplay
                )}
              </span>}
              <span className="study-list-value-text">
                {props.data.row.original.studyDescription}
              </span>
            </div>
          </div>

          <span
            className="study-list-patientDetails-id"
            style={{ marginBottom: "10px" }}
          >
            <span className="study-list-mobile-top-badge-container">
              {props.data.row.original.edited &&
                props.data.row.original.reportDoneStatus < 2 && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: " #CE980D" }}
                  >
                    EDITED
                  </span>
                )}
            </span>
          </span>
        </div>
      </Stack>
    </>
  );
};

export default MobileListComponent;

const ActionDropdown = ({ menuItems }) => {
  const [showContextualMenu, setShowContextualMenu] = useState(false);
  const { getThemeColor } = useContext(themeContext);
  const onHideContextualMenu = useCallback(
    () => setShowContextualMenu(false),
    []
  );
  const linkRef = useRef(null);

  const contextMenuStyle = {
    root: {
     backgroundColor: getThemeColor('action-details-background'),
     borderRadius: "5px",
    border: "1px solid #585858",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
    },
    item: {
      selectors: {
      ":hover": {
        backgroundColor:'green'
      },
      },
    },
  };

  return (
    <>
      <div
        ref={linkRef}
        className="study-list-actions-icon study-list-context-menu"
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "5px",
          marginLeft: "14px"
        }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setShowContextualMenu((prev) => !prev);
        }}
      >
        <Icon
          iconName="MoreVertical"
          style={{fontSize:"18px"}}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setShowContextualMenu((prev) => !prev);
          }}
        ></Icon>
        <ContextualMenu
          styles={contextMenuStyle}
          items={menuItems()}
          hidden={!showContextualMenu}
          target={linkRef}
          onItemClick={onHideContextualMenu}
          onDismiss={onHideContextualMenu}
          isBeakVisible={false}
        />
      </div>
    </>
  );
};
